import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useHistory, Link, useLocation } from "react-router-dom";
import apiService from "../services/api.service";
import { appPath } from "../utils/appSlug";
import PasswordToggle from "../Components/PasswordToggle";
import "./login.css";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ResetPassword = ({ appSlug }) => {
  const loginPath = appPath(appSlug, 'login');
  let history = useHistory()
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);

  let query = useQuery();

  useEffect(() => {
    const verifyToken = async () => {
      await apiService.verifyPasswordReset(query.get('key'), appSlug)
      .catch(() => {
        history.push(loginPath, { 'failReason': "Il link per il reset della password non è più valido, Richiedine un altro se necessario"})
      })
    }
    verifyToken()
  }, [history, query, appSlug, loginPath])

  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const onPasswordConfirmChange = (e) => {
    setPasswordConfirm(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonDisabled(true)
    try {
      await apiService.resetPassword(query.get('id'), query.get('key'), password, appSlug);
      localStorage.removeItem('authError')
      history.push(loginPath, { 'successReason': "Password cambiata, puoi effettuare l'accesso usando la tua nuova password" })

    } catch (error) {
      setButtonDisabled(false)
    }
  };

  const checkPasswordMismatch = () => {
    if (passwordConfirm === "") {
      if (password !== "") {
        return true
      }
    }
    if (passwordConfirm === password) {
      return false
    } else {
      return true;
    }
  }

  return (
    <div className="login-page login-page--platform login-page--reset">
      <div className="login-card">
        <p className="login-kicker">Area riservata</p>
        <h1 className="login-title">Nuova password</h1>
        <p className="login-subtitle">Inserisci e conferma la tua nuova password.</p>
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <PasswordToggle
              value={password}
              onChange={onPasswordChange}
              placeholder="Inserisci la password"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
            <Form.Label>Conferma password</Form.Label>
            <PasswordToggle
              value={passwordConfirm}
              onChange={onPasswordConfirmChange}
              placeholder="Inserisci nuovamente la password"
              isValid={password === "" ? false : !checkPasswordMismatch()}
              isInvalid={checkPasswordMismatch()}
              onPaste={(e) => { e.preventDefault() }}
            />
            <Form.Control.Feedback type="invalid">
              Le password non corrispondono
            </Form.Control.Feedback>
          </Form.Group>
          <Button
            className="login-submit"
            size="lg"
            variant="primary"
            disabled={checkPasswordMismatch() || buttonDisabled}
            type="submit">
            Cambia password
          </Button>
        </Form>
        <p className="login-register-prompt">
          <Link to={loginPath}>Torna al login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
